
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Phase II: Transmettrez-vous le virus?`}</h3>
    <p>{`Après deux à quatre jours `}<strong parentName="p">{`vous devenez contagieux`}</strong>{` sans même vous en
apercevoir. Une personne reste contagieuse pendant une moyenne de 5 jours et
demi, mais cela peut durer jusqu'à deux semaines.`}</p>
    <p><strong parentName="p">{`Attention!`}</strong>{` `}<em parentName="p">{`Si vous scrollez trop lentement, vous causerez davantage
d'infections!`}</em></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;